import type { LedgerQuestion } from '../../../api/questionQualityApi';

/**
 * Who a question belongs to, beside its id.
 *
 * Only what is NOT the default gets a pill. Most of the corpus is the public
 * library, authored by us; saying so on every row would be a column of noise
 * that hides the rows where it matters. A pill here means "this one is
 * somebody's" — and both can be true at once, because a teacher's question
 * usually sits inside a tenant.
 *
 * The slug and the name rather than the ids: a tenant id and a user id identify
 * nothing on sight, so the ids stay in the tooltip where a reader who needs to
 * grep for one can still find it.
 */
export function OwnerPills({ q }: {
    q: Pick<LedgerQuestion, 'tenantId' | 'tenantSlug' | 'teacherId' | 'teacherName'>;
}) {
    return (
        <>
            {q.tenantId && (
                <span className="qq-ownerpill qq-ownerpill--tenant" title={`Tenant · ${q.tenantId}`}>
                    {q.tenantSlug ?? q.tenantId}
                </span>
            )}
            {q.teacherId && (
                <span
                    className="qq-ownerpill qq-ownerpill--teacher"
                    title={`Teacher's question · ${q.teacherId}`}
                >{q.teacherName ?? q.teacherId}</span>
            )}
        </>
    );
}
